(function () {
    'use strict';

    angular
        .module('app')
        .controller('TicketCheckoutCompleteController', TicketCheckoutCompleteController);

    TicketCheckoutCompleteController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'eventTracker', 'authenticator'];

    function TicketCheckoutCompleteController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, eventTracker, authenticator) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.showTicket = showTicket;
        vm.hideTicket = hideTicket;

        function init() {
            vm.isLight = authenticator.isLight();
            vm.loading = true;
            getCheckout().then(getConcertDetails).then(function() {
                if(vm.isLight) {
                    vm.wasLight = true;
                    vm.user_email = $cookies.get('_user_email_');
                    authenticator.logout();
                    getUserStatus();
                }
                vm.loading = false;
            });
        }

        function getUserStatus() {
            $http.post('/app/api/user/get/', {user_email: vm.user_email})
                .then(function (response) {
                    vm.has_user = !response.data.is_light;
                });
        }

        function getCheckout() {
            return $http.post('/app/api/checkout/get/', { checkout_id: parseInt($stateParams.checkout_id) })
                .then(function (response) {
                    vm.checkoutItems = response.data.items
                    vm.checkoutTotal = response.data.checkout_total
                    vm.checkoutCurrency = response.data.currency
                    if($stateParams.concert && $stateParams.ticket_amount){
                        eventTracker.purchase($stateParams.concert, $stateParams.ticket_amount, response.data.checkout_id, vm.checkoutTotal);
                    }

                    vm.checkoutItems.forEach(checkoutItem => {
                        if (checkoutItem.checkout_item_object_type == 'Concert') {
                            vm.concert_id = checkoutItem.checkout_item_object_id
                            vm.number_of_tickets = checkoutItem.num_of_tickets;
                        }
                    });
                });
        }

        function getConcertDetails() {
            return $http.get('api/concerts/by_id/' + vm.concert_id + '/')
                .then(function (response) {
                    vm.concert = response.data;
                });
        }

        function close() {
            return $state.go('frontpage');
        }


        function showTicket(ticket){
            vm.selected_ticket = ticket;
            vm.selected_ticket.map_link = "https://www.google.com/maps/place/" + vm.selected_ticket.concert_address + ",+" + vm.selected_ticket.concert_zip + "+" + vm.selected_ticket.concert_city + "/";
            vm.show_ticket = true;
            // $rootScope.no_scroll = true;
            disableScrolling();
        }

        function hideTicket(){
            vm.show_ticket = false;
            $rootScope.no_scroll = false;
            enableScrolling();
        }

        function disableScrolling(){
            var x=window.scrollX;
            var y=window.scrollY;
            window.onscroll=function(){window.scrollTo(x, y);};
        }

        function enableScrolling(){
            window.onscroll=function(){};
        }

    }
})();
